
<script>
import { mapActions, mapGetters } from 'vuex'

import StaticData from '../../static'
import FormMixin from '@mixins/form'
import moment from 'moment/moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import NoteComponent from '@components/dialogs/note.vue'
import error from '@utils/error'

export default {
  components:{
    VuePerfectScrollbar,
    // Activities: () => import('../tabs/activities.vue'),
    // TableUser: () => import('../../table/user.vue'),
    Dialog: () => import('@components/dialogs')
  },
  mixins: [ FormMixin ],
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      model:{
        full_name: '',
        email: '',
        contact_no: '',
        work_experiences:[],
        education_background:[],
        skills:[],
        tags:[],
        attachments:[],
        function_id:[],
        industry_id:[],
        activities:[],
        role: {}
      },
      users:[],
      recruiters:[],
      downloadKey: 1,
      modalErrorMessage:'',
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      openedDialog: '',
      type: '',
      isNotExpanded: {
        industry_id: false,
        function_id: false,
        brand_id: false
      },
      expandLimit: 2
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    rowId() {
      let parameters = this.parameters || {}
      return parameters.rowId
    },
    addRecruiterComponent() {
      return () => import('./create.vue')
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
    computedStaticData () {
      return StaticData
    },
    present_work: function() {
      let position
      for(var key in this.model.work_experiences){
        var work = this.model.work_experiences[key]
        if(work.present == true) {
          position = work.position
        }
      }
      return position
    },
    currency_symbol(){
      var symbol = ""
      if(this.model.currency_id){
        symbol = this.model.currency_id.symbol
      }
      return symbol
    },
    computedSize() {
      let innerWidth = window.innerWidth
      let size

      if (innerWidth && innerWidth < 560)
        size = true;
      else 
        size = false;

      return size      
    },
    addNoteComponent() {
      return NoteComponent
    },
  },
  updated() {
    this.handleResize()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  created() {
    if (this.rowId) {
      this.fetchData()
    }
  },
  watch: {
    rowId: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()

      if (this.openedDialog) {
        this.$refs[this.openedDialog].hide()
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('user', ['findUser', 'uploadAttachment', 'downloadAttachment', 'deleteAttachment', 'create']),
    activeTab(typ) {
      var tab = this.$route.query.tab || 'recruiters'
      return tab == typ
    },
    dateFormatted(val, format){
      return moment(val).format(format || 'YYYY-MM-DD')
    },
    onClickAddRecruiter() {
      this.type = 'individual'
      this.$refs.addRecruiter.show()
    },
    onClickAddAttachment() {
      let attachmentField = this.$refs.attachmentField

      if (attachmentField) {
        attachmentField.click()
      }
    },
    addAttachment(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        
        var formData = new FormData();

        formData.append("file", input.files[0]);
        formData.append("id", this.rowId);

        this.uploadAttachment(formData).then(res => {

          if(res.data.success == true) {
            this.model.attachments.push(res.data.attachment)
            this.toggleLoading()
          }else{
            this.toggleLoading()
          }
          
        })
      }
    },
    onDownloadAttachment(uiid){
      this.downloadAttachment({
        id:uiid
      }).then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }
        else {
          if(res.data.attachment){  
            const url = res.data.baseUrl + '/' +  res.data.attachment.path
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', res.data.attachment.originalname) //or any other extension
            link.setAttribute('target', '_blank') //or any other extension
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        }
      })
    },
    onDeleteAttachment(uiid, idx){
      this.deleteAttachment({
        id:uiid
      }).then(res => {
        if(res.data.success){
          alert('Attachment was successfully deleted!')
        }
        this.model.attachments.splice(idx, 1)
      })
    },
    async fetchData(){
      await this.findUser({
        id:this.rowId
      })
      .then(res => {
        this.model = res.data.data
        this.model.notes = res.data.notes || []
      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onClickActions(ref, data, type = 'reference') {
      this.$emit('onClick', { ref: ref, model: data, type })
    },
    onAddRecruiter(val) {
      let reference = val || {}
      let model = { ...reference.model }
      model.pid = reference.pId
      model._type = reference.type

      this.create(model)
      .then(result => {
        if (result && result.data) {
          this.$refs.addRecruiter.hide()
          this.$refs.recruitmentTable.fetchData()
        }
      })
      .catch(err => {
        let error = err.response.data
        
        if (error.errors) {
          let { errors } = error
          for (let key in errors) {
            this.$bvToast.toast(`${errors[key].message}`, {
              title: "Notification",
              variant: "danger"
            })
          }
        }
        else if (error && error.msg) {
          this.$bvToast.toast(`${error.msg}`, {
            title: "Error!",
            variant: "danger"
          })
        }
      })
    },
    onAddNote(val){
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      this.$store.dispatch('user/createNote', {
        id: this.model._id,
        note: model.note
      })
      .then(res => {
        var data = res.data
        this.submitted = !this.submitted
        this.fetchData()
        this.$refs.addNote.hide()
        this.$bvToast.toast(data.toastMessage, {
          title: 'Notification',
          variant:'success'
        })
      })
      .catch((err) => error.errorHandler(err, this.$bvToast))
    },
  },
}
</script>

<template>
  <div class="w-100 modal_body_container d-flex justify-content-center align-items-start flex-row">
    <div class="col-12 px-0 mx-2">
      <div class="personal_info_container bg-white">
        <div class="d-flex justify-content-start">
          <div class="image_container">
            <img
              ref="imageAvatar"
              :src="model.avatar_path ? model.avatar_path : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973461_960_720.png'"
              class="avatar-xxl rounded-lg"
              alt=""
            />
          </div>
          <div 
            class="name_container d-flex flex-column align-items-start pl-4 my-2 w-100"
          >
            <p class="mb-1 h4 mt-0">{{ model.recruitment_type == 'company' ? model.company_name : model.full_name }}</p>
            <p class="mb-1">{{ model.role.name | capitalize }}</p>
            <p 
              class="badge badge-pill mb-1"
              :class="model.active ? 'badge-success' : 'badge-danger'"
            >
              {{ model.active ? "Active" : "Inactive" }}
            </p>
            
            <div class="button_container text-dark bg-white">
              <input 
                type='file' 
                ref="attachmentField"
                hidden=true
                @change="addAttachment"
              />
              <b-nav-item-dropdown
                variant="black"
                class="dropdown d-none d-lg-block"
              >
                <template v-slot:button-content>
                  <button class="btn btn-primary btn2-xs py-1 px-2 t" >
                    Edit User
                  </button>
                </template>
                <!-- item-->
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  title="Edit"
                  @click="onClickActions('editUser', model)"
                >
                  <i class="uil uil-edit mr-1" />
                  Edit
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  title="Add Attachments"
                  @click="onClickAddAttachment()"
                >
                  <i class="uil uil-file-plus mr-1" />
                  Add Attachment
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  :title="model.active ? 'Deactivate' : 'Activate'"
                  v-if="user.role.role == 'administration'"
                  @click="onClickActions('onActivate', model, 'function')"
                >
                  <i
                    class="mr-1"
                    :class="model.active ? 'uil-user-times' : 'uil-user-check'"
                  />
                  {{ model.active ? 'Deactivate' : 'Activate' }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="onClickActions('userChangePassword', model)" 
                >
                  <i class="uil uil-lock-open-alt mr-1" />
                  Change Password
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </div>

            <!-- <div class="mt-1 h6">
              <a
                v-for="(socmed, idx) in computedStaticData.socialMedias" 
                :key="idx" 
                :href="model[socmed.model]"
                :title="socmed.name"
                target="_blank"
                class="mx-1"
              >
                <i :class="socmed.iconClass"></i>
              </a>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div
            class="py-2 col-6 d-flex"
            v-for="(details, idx) in computedStaticData.personalDetails"
            :key="idx"
          >
            <p class="mb-0 h5_5 mr-3" :title="details.name">
                <i :class="details.iconClass"></i>
            </p>
            <p class="mb-0" :title="details.name">
              <span v-if="typeof details.model == 'string'">{{ model[details.model] || 'N/A' }}</span>
              <span
                v-else-if="typeof details.model == 'object'" 
                v-for="(str, idx) of details.model" 
                :key="idx"
              >
                {{ !model[str] && details.model.length == idx + 1 ? 'N/A' : model[str] ? model[str] : '' }}
              </span>
            </p>
          </div>
          <div 
          class="d-flex flex-row justify-content-start flex-wrap align-items-center"
          v-if="model.recruitment_type == 'company'"
          >
            <span class="h5_5 mb-0 col-5">Contract Start Date</span>
            <span class="h5_5 mb-0">
              {{model.contract_start_date ? dateFormatted(model.contract_start_date) : 'N/A'}}
            </span>
          </div>
          <div
            class="d-flex flex-row justify-content-start flex-wrap align-items-center"
            v-if="model.recruitment_type == 'company'"
          >
            <span class="h5_5 mb-0 col-5">Contract End Date</span>
            <span class="h5_5 mb-0">
              {{model.contract_end_date ? dateFormatted(model.contract_end_date) : 'N/A'}}
            </span>
          </div>
          <div class="col-12 d-flex flex-row justify-content-start flex-wrap align-items-center">
            <span class="h5 ">{{ $t('company.form.fees') }}: </span>
            <span class="h5 ml-3">
              {{ model.fixed && model.rate ? model.rate.$numberDecimal : '' | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }}
              {{ !model.fixed && model.rate ? model.rate.$numberDecimal + '%' : '0' }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-for="(card, idx) in computedStaticData.smallCards"
        :key="idx"
        class="my-2 bg-white industry_container"
      >
        <div class="inputRoot">
          <div class="rootLabel">{{ card.name }}</div>
          <div class="">
            <div class="">
              <div 
                class="rootList"
                :class="model[card.model].length > expandLimit && !isNotExpanded[card.model] ? 'col-8' : 'col-12'"
              >
                <div 
                  class="rootItem ml-3" 
                  v-for="item in model[card.model].slice(0, isNotExpanded[card.model] ? model[card.model].length : expandLimit)"
                  :key="item._id"
                >
                  {{ item.name }}
                </div>
              </div>
  
              <div class="col-4" v-if="model[card.model].length > expandLimit && !isNotExpanded[card.model]">
                <button type="button" aria-label="Close" class="btn2 btn2-tertiary mb-2"
                  @click="isNotExpanded[card.model] = !isNotExpanded[card.model]"
                >
                  +{{ model[card.model].length - expandLimit }} {{ card.name }}
                </button>
              </div>

              <div class="py-2 ml-3" v-if="model[card.model].length == 0">
                <span>{{ card.noContentMessage }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-2 bg-white attachment_container mb-5">
        <div class="title border-bottom py-2 h5 my-0">
          Attachments
        </div>
        <div v-if="!model.attachments.length">No Available Attachment(s)</div>
        <VuePerfectScrollbar v-else style="max-height: 300px">

          <div class="card mb-2 shadow-none border" style="background: #F2F2F2;"
            v-for="(item, idx) in model.attachments"
            :key="`item-${item._id}`"
          >
            <div class="p-1 px-2">
              <div class="row align-items-center">
                  <div class="col-auto">
                    <img 
                      src="@assets/pdf-file-icon.svg" 
                      class="avatar-sm rounded" 
                      alt="file-image"
                    >
                  </div>
                  <div 
                    class="col pl-0" 
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  >
                    <a 
                      href="javascript:void(0);" 
                      class="text-muted font-weight-bold"
                    >
                      {{ item.originalname }}
                    </a>
                    <p class="mb-0">{{ item.size.$numberDecimal | bytes }}</p>
                  </div>
                  <div class="col-auto">
                    <a
                      @click="onDownloadAttachment(item._id, idx)"
                      data-toggle="tooltip" 
                      data-placement="bottom" 
                      title="Download Attachment" 
                      class="btn btn-link text-muted btn-lg p-0" 
                      data-original-title="Download"
                    >
                        <i class="uil uil-cloud-download font-size-14"></i>
                    </a>
                    <!-- <a
                      @click="onDeleteAttachment(item._id, idx)"
                      data-toggle="tooltip" 
                      data-placement="bottom" 
                      title="Delete Attachment" 
                      class="btn btn-link text-danger btn-lg p-0" 
                      data-original-title="Delete"
                    >
                        <i class="uil uil-multiply font-size-14"></i>
                    </a> -->
                  </div>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </div>
    <!-- <div class="d-flex flex-column justify-content-center align-items-center col-8s">
      <div 
        class="w-100 d-flex justify-content-center align-items-center flex-column" 
        v-if="model.recruitment_type == 'company'"
      >
        <div class="d-flex justify-content-around w-100 align-items-center flex-wrap">
          <div
            class="card right_card_container"
            v-for="(rightCard, idx) in computedStaticData.rightCards"
            :key="idx"
          >
            <div class="card-body">
              <div class="row" >
                <div class="px-2">
                  <label>{{ rightCard.name }}</label>
                  <div v-if="model[rightCard.model]">{{ model[rightCard.model] }}</div>
                  <div v-else>{{ rightCard.emptyMessage }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-tabs class="card_width_container">
          <b-tab
            title="Recruiter(s)"
            :active="activeTab('recruiters')"
            class="bg-white p-4"
          >
            <h5
              class="card-title pb-2 border-bottom d-flex flex-row justify-content-between align-items-center"
            >
              Recruiter(s) 
              <button
                class="btn2 btn2-primary btn-sm mr-1 mb-3 mb-sm-0"
                @click="onClickAddRecruiter()"
                v-if="user.role.role == 'administration' || user.role.role == 'recruitment'"
              >
                <i class="uil-plus mr-1"></i> Add Recruiter
              </button>
            </h5>
            <TableUser
              ref="recruitmentTable"
              class="w-100 table_component"
              :header="false"
              :noPerPage="false"
              :useAs="'recruiter'"
              :param="{
                user_id: model._id,
                recruitment_type: 'individual'
              }"
            />
          </b-tab>
          <b-tab title="Activities" :active="activeTab('activities')">
            <Activities class="p-4" :model="model" />
          </b-tab>
          <b-tab title="Notes" class="bg-white p-4">
            <div class="card shadow-none">
              <div
                class="d-flex tab_card_content_container align-items-center flex-wrap"
                :class="model.notes && model.notes.length && model.notes.length >= 2 ? 'justify-content-between' : 'justify-content-start'"
              >
                <h5
                  class="card-title pb-2 border-bottom d-flex flex-row justify-content-between align-items-center w-100"
                >
                  Note(s) 
                  <button
                    class="btn2 btn2-primary btn-sm mr-1 mb-3 mb-sm-0"
                    @click="$refs.addNote.show()"
                    v-if="user.role.role == 'administration' || user.role.role == 'recruitment'"
                  >
                    <i class="uil-plus mr-1"></i> Add Note
                  </button>
                </h5>


                <div class="note" v-if="model.notes.length == 0">
                  No user note added.
                </div>

                <div
                  class="note note_cards rounded my-2"
                  v-for="(note, idx) in model.notes"
                  :key="note._id || idx"
                  v-html="note.description"
                />

              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div v-else class="card card_width_container">
        <b-tabs class="col-12s application-view-height bg-white">
          <b-tab title="Activities">
            <div class="card">
              <div class="card-body">
                <Activities :model="model" />
              </div>
            </div>
          </b-tab>
          <b-tab title="Notes" class="bg-white p-4">
            <div class="card shadow-none">
              <div
                class="d-flex tab_card_content_container align-items-center flex-wrap"
                :class="model.notes && model.notes.length && model.notes.length >= 2 ? 'justify-content-between' : 'justify-content-start'"
              >
                <h5
                  class="card-title pb-2 border-bottom d-flex flex-row justify-content-between align-items-center w-100"
                >
                  Note(s) 
                  <button
                    class="btn2 btn2-primary btn-sm mr-1 mb-3 mb-sm-0"
                    @click="$refs.addNote.show()"
                  >
                    <i class="uil-plus mr-1"></i> Add Summary
                  </button>
                </h5>


                <div class="note" v-if="model.notes.length == 0">
                  No user note added.
                </div>

                <div
                  class="note note_cards rounded my-2"
                  v-for="(note, idx) in model.notes"
                  :key="note._id || idx"
                  v-html="note.description"
                />

              </div>
            </div>
          </b-tab>
        </b-tabs>
        <div class="card-body">
          <Activities :model="model" />
        </div>
      </div>
    </div> -->
    <Dialog
      ref="addRecruiter"
      size="xl"
      yesText="Create"
      noText="Cancel"
      title="Add Recruiter"
      centered
      :parameters="{ type, userData: model, id: model._id }"
      :component="addRecruiterComponent"
      @onYes="onAddRecruiter"
    />

    <Dialog
      ref="addNote"
      centered
      size="md"
      title="Add Note"
      yesText="Add"
      noText="Cancel"
      :parameters="{ submitted }"
      :component="addNoteComponent"
      @onYes="onAddNote"
    />
  </div>
</template>

<style lang="scss">
  .ps__rail-y{
    z-index:1
  }
  .ps__rail-x{
    z-index:1
  }

  .personal_info_container,
  .activities_container,
  .industry_container,
  .function_container,
  .brand_container,
  .attachment_container {
    border-radius: 10px;
    overflow: auto;
    padding: 15px 20px;
  }

  .h5_5 {
    font-size: 1rem!important;
    font-weight: 500;
  }

  .twitter {
    color: #1da1f2;
  }

  .close {
    padding: 0!important;
    margin: 0!important;
    float: none!important;
  }

  .image_container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .button_container {
      z-index: 999;
      cursor: pointer;
      position: absolute;
      width: 50px;
      top: 0;
      right: 0;
      transition: width 0.2s;
      display: flex;
      align-items: center!important;
      justify-content: center;
    }
  }

  .smallCardsBadgeContainer {
    max-height: 75px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .smallCardsBadgeContainer::-webkit-scrollbar {
    display: none;
  }

  header {
    padding-top: 17px!important;
    padding-bottom: 17px!important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center!important;
  }

  .table_component {
    max-height: 300px;
  }

  .icon_class {
    transform: rotate(180deg);
    transition: transform 0.2s;
  }

  .custom-tooltip > .tooltip-inner {
    background: rgb(148, 148, 148)!important;
    font-size: 8px!important;
  }

  @media screen and (min-width: 1200px) {
    .col-3s {
      flex: 0 0 28%;
      max-width: 28%;
    }
    .col-8s {
      flex: 0 0 68%;
      max-width: 68%;
    }

    .col-5s {
      flex: 0 0 38%;
      max-width: 38%;
    }

    .right_card_container {
      flex: 0 0 30%;
      max-width: 30%;
    }

    .card_width_container {
      width: 97%;
    }
   }

  @media screen and (max-width: 580px) {
    .personal_info_container {
      padding: 1;
    }

    .col-3s {
      margin-top: 150px!important;
      width: 100%!important;
    }
    .modal_body_container {
      flex-direction: column!important;
    }
  }
</style>